import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';
declare const google: any; // 声明 google 对象

@Injectable({
  providedIn: 'root',
})
export class GoogleAuthService {
  private renderer: Renderer2;

  constructor(rendererFactory: RendererFactory2) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  loadGoogleScript(): Promise<any> {
    return new Promise((resolve, reject) => {
      if (typeof google !== 'undefined') {
        resolve(google);
        return;
      }
      const script = this.renderer.createElement('script');
      script.src = 'https://accounts.google.com/gsi/client';
      script.async = true;
      script.defer = true;
      script.onload = () => resolve(google);
      script.onerror = () => reject(new Error('Google script load failed'));
      this.renderer.appendChild(document.body, script);
    });
  }
}
